import React from "react";

const NumberPad = ({ onClick, color }) => {
	const handleNumberClick = (num) => {
		// Ensure we're passing the correct value
		console.log('NumberPad clicked:', num); // Debug log
		if (onClick && typeof onClick === 'function') {
			onClick(num);
		}
	};

	const renderNumber = (num) => (
		<div
			key={`number-${num}`} // Use stable, predictable key
			style={{ color }}
			className="dig number-dig"
			onClick={() => handleNumberClick(num)}
		>
			{num}
		</div>
	);

	// Create number buttons 1-9
	const numberButtons = [];
	for (let i = 1; i <= 9; i++) {
		numberButtons.push(renderNumber(i));
	}

	return (
		<div className="dial-pad">
			<div className="digits">
				{/* Numbers 1-9 */}
				{numberButtons}
				
				{/* Asterisk button */}
				<div
					key="asterisk"
					className="dig number-dig asterisk"
					style={{ color }}
					onClick={() => handleNumberClick("*")}
				>
					*
				</div>
				
				{/* Zero button */}
				<div
					key="zero"
					className="dig number-dig zero"
					style={{ color }}
					onClick={() => handleNumberClick(0)}
				>
					0
				</div>
				
				{/* Hash button */}
				<div
					key="hash"
					className="dig number-dig hash"
					style={{ color }}
					onClick={() => handleNumberClick("#")}
				>
					#
				</div>
			</div>
		</div>
	);
};

export default NumberPad;